// extracted by mini-css-extract-plugin
module.exports = {"sorting":"sorting-3qcNn"};